<template>
  <fragment>
    <template v-if="isAdmin">
      <Dashboard />
    </template>
    <template v-else-if="isStoreKeeper">
      <DashboardProducer />
    </template>
    <template v-else-if="isAffiliate">
      <DashboardAffiliate />
    </template>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import Dashboard from "@/views/Dashboard.vue";
import DashboardProducer from "@/views/DashboardProducer.vue";
import DashboardAffiliate from "@/views/DashboardAffiliate.vue";

export default {
  name: "Home",
  metaInfo: {
    title: "Home | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Home | ElevenTickets",
      },
    ],
  },
  components: {
    Dashboard,
    DashboardProducer,
    DashboardAffiliate,
  },
  data() {
    return {
      tab: null,
    };
  },
  computed: {
    ...mapGetters([
      "dashEvent",
      "isOpenModal",
      "isAdmin",
      "isAffiliate",
      "isStoreKeeper",
    ]),
  },
};
</script>
